import { removeNamespace } from '@/utils/helpers'
import $http from '@/plugins/axios'

export const NATIONS_TYPES = {
  mutations: {
    SET_LOADING: 'nations/SET_LOADING',
    SET_DID_ERROR: 'nations/SET_DID_ERROR'
  },
  actions: {
    submitLead: 'nations/submitLead'
  }
}

// Must represent CTF options on the Contact Form Model
export const FormTypes = Object.freeze({
  contactRequest: 'Contact Request',
  commonSense: 'Common Sense Guide',
  promotionalItem: 'Promotional Item',
  newsletterSignUp: 'Newsletter Signup',
  agentTraining: 'Agent Training'
})

const _types = removeNamespace('nations', NATIONS_TYPES)

const state = () => ({
  loading: false,
  didError: false
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_DID_ERROR] (state, bool) {
    state.didError = bool
  }
}

const actions = {
  [_types.actions.submitLead] ({ rootState, commit }, payload) {
    commit(_types.mutations.SET_LOADING, true)
    commit(_types.mutations.SET_DID_ERROR, false)
    payload.url = window.location.href
    const quizResult = rootState.quiz.result
    if (quizResult) {
      payload.quizResult = 'Quiz Result: ' + quizResult.fields.name
    }
    const contactEmail = rootState.site.siteConfig.contactEmail
    if (contactEmail) {
      payload.contactEmail = contactEmail
    }
    const agentTrainingEmail = rootState.site.siteConfig.agentTrainingEmail
    if (agentTrainingEmail) {
      payload.agentTrainingEmail = agentTrainingEmail
    }

    return $http().post('ContactFunction', payload, { handleError: false })
      .catch(() => commit(_types.mutations.SET_DID_ERROR, true))
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
